/**
 * Wraps an accordion list + its paired media column. Listens for native
 * `toggle` events (captured, since `toggle` does not bubble) and swaps the
 * active image to match whichever row is open.
 */
class AccordionImageList extends HTMLElement {
  connectedCallback() {
    this.addEventListener('toggle', this.#handleToggle, true);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.#handleToggle, true);
  }

  /**
   * @param {Event} event
   */
  #handleToggle = (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;

    const id = details.dataset.accordionId;
    if (!id) return;

    this.querySelectorAll('[data-accordion-image]').forEach((image) => {
      image.classList.toggle('is-active', image instanceof HTMLElement && image.dataset.accordionImage === id);
    });
  };
}

if (!customElements.get('accordion-image-list')) {
  customElements.define('accordion-image-list', AccordionImageList);
}
